import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import { AlightStateType } from "../../types/alight-state";
import { NavUrl } from "@alme/types/response/NavUrl";

function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
async function validateFunctionExistance(timeout: number): Promise<any> {
    await delay(timeout);

    // @ts-ignore
    return (Promise.resolve(window.enableIVAasService || window.enableIVA2Features));
}

function isDesktop(state: AlightStateType | undefined, settings: AlightCustomSettingsType) {
    return state?.DeviceType === settings.mobileConstants.deviceTypes.desktop
}

function getQueryParams(url: string): Record<string, string | null> {
    const params: Record<string, string | null> = {};
    const [baseUrl, queryString] = url?.split(/\?(.*)/g); 

    if (queryString) {
        const queryArray: string[] = queryString.split('&'); 
        
        let previousKey: string | null = null; 

        queryArray.forEach((param: string) => {
            const [key, value] = param.split('=');

            if (value === undefined && previousKey) {
                // Append to previous key’s value if missing `=`
                params[previousKey] += `&${key}`;
            } else {
                params[key] = value ? decodeURIComponent(value) : null; 
                previousKey = key; 
            }
        });
    }

    return params;
}

function sanitizeValue(val: string) {
    return val?.replace(/[<>]/g, '');
}

function getAlightLinkDetails(urlAddress: string) {
    const decodedurl = decodeURI(urlAddress);
    let nav_url = decodedurl?.split('?');
    if (nav_url.length === 1) {
        return { 'type': ``, 'source': ``, 'name': ``, 'gnrc1': ``, 'gnrc2': `` };
    }
    const params = getQueryParams(decodedurl);
    let type = '';
    let source = 'UPoint';
    let name = '';
    let gnrc1 = '';
    let gnrc2 = '';
    if ('uce' in params) {
        let isUCE = params.uce;
        if (isUCE === 'true') {
            source = 'UCE'
        }
    }
    if ('gnrc1' in params) {
        gnrc1 = sanitizeValue(params.gnrc1 ?? "");
    }
    if ('gnrc2' in params) {
        gnrc2 = sanitizeValue(params.gnrc2 ?? "");
    }
    if ('advAssetGrp' in params) {
        type = 'advAssetGrp';
        name = sanitizeValue(params.advAssetGrp ?? "");
    }
    else if ('linkId' in params) {
        type = 'linkId';
        name = sanitizeValue(params.linkId ?? "");
    }
    else if ('qscEvent' in params) {
        type = 'qscEvent';
        name = sanitizeValue(params.qscEvent ?? "");
    }
    return {'type':`${type}`, 'source':`${source}`, 'name':`${name}`, 'gnrc1':`${gnrc1}`, 'gnrc2':`${gnrc2}`};
}

function checkCounterAreaVisibility(language: string | undefined, state: AlightStateType | undefined, settings: AlightCustomSettingsType) {
    const textCountClass = settings.classNames.inputboxCharacterCounter;
    const textCountArea = document.getElementsByClassName(textCountClass)[0] as HTMLElement;

    if (textCountArea != null && textCountArea != undefined) {
        const liveChatStatus = state?.LiveChat.SessionState;

        if (liveChatStatus != settings.livechat.sessionState.offline) {
            textCountArea.style.display = "none";
        }
        else {
            if (language === "zh-CN" || language === "ar-SA") {
                textCountArea.style.display = "none";
            } else {
                textCountArea.style.display = "block";
            }
        }
    }
}


async function waitForIvaFunction(maxCount = 30): Promise<boolean> {
    let timeout: number = 0;
    let count: number = 0;

    while (true) {
        const result = await validateFunctionExistance(timeout);

        if (result != undefined) {
            return Promise.resolve(true);
        }

        count = count + 1;

        if (count > 0 && count < 15) {
            timeout = 500;
        }

        else if (count < maxCount) {
            timeout = 1000;
        }

        else {
            // assume no function exists, stop looking for it and stop initialization
            return Promise.resolve(false);
        }
    }
}

export {
    waitForIvaFunction,
    isDesktop,
    checkCounterAreaVisibility,
    getAlightLinkDetails

};


// WEBPACK FOOTER //
// ./modules/lib-alight-library/lib-alight-library.ts